module.exports = __webpack_public_path__ + "components/Modals/MeasureTools/icons/punkt.png?cd93ee84";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/MeasureTools/icons/punkt.png
// module id = 2367
// module chunks = 0